
import logomark from '~/assets/images/tidal-logomark.svg?data';

export default {
    props: {
        title: {
            type: String,
            default: '',
        },
    },
    computed: {
        /** @returns {string} */
        logoSrc() {
            return logomark;
        },
    },
};
